import React, { FormEvent, useContext, useState, useEffect } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { processNodeDelete, processNodeFormSubmit, nodeDescription, formSchema } from "./functions/workflow-merge-node-configuration";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { NodeDataStoreMultiSelectWidget } from "./components/NodeDataStoreMultiSelectWidget";
import {
    Button
} from '@mui/material';


export const WorkflowMergeNodeConfiguration = () => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog() {
        context.toggleShowMergeModal(false);
    }

    const handleFormSubmit = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode() {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }



    const uiSchema: UiSchema = {
        'data_store': {
            'ui:widget': 'NodeDataStoreMultiSelectWidget',
            'ui:options': {
                'classNames': 'data-management'
            }
        },
        'data_management': {
            'ui:widget': 'NodeDataStoreMultiSelectWidget',
            'ui:options': {
                'classNames': 'data-management'
            }
        },
        'merge_from_data': {
            'ui:widget': 'NodeDataManagementWidget',
            'ui:options': {
                'classNames': 'data-management'
            }
        },
        'ui:order': [ 'data_store', 'merge_type', 'allOf', 'merge_from_data', 'include_duplicates', 'data_management' ]
    }

    const widgets: RegistryWidgetsType = {
        NodeDataManagementWidget: NodeDataStoreSelectWidget,
        NodeDataStoreMultiSelectWidget: NodeDataStoreMultiSelectWidget
    }

    return (
        <DefaultFormDialog
            open={ context.showMergeModal }
            title={ "Merge Node" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                id="workflow-sitemap-node-configure"
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>

                </div>
            </Form>
        </DefaultFormDialog>
    );
}